import { Form } from 'antd';

import Input from '@/components/Inputs/Input';

export const CafeIdField = (props: { required?: boolean }) => {
  const { required = false } = props;
  return (
    <Form.Item
      label="Cafe ID"
      required={required}
      name="cafe_id"
      rules={
        required ? [{ required: true, message: 'Cafe ID is required' }] : []
      }
    >
      <Input placeholder="Fill Cafe ID" sizeType="m" />
    </Form.Item>
  );
};
